import { render, staticRenderFns } from "./AcordoTabelaDash.vue?vue&type=template&id=2bc12df5&scoped=true&lang=html&"
import script from "./AcordoTabelaDash.vue?vue&type=script&lang=js&"
export * from "./AcordoTabelaDash.vue?vue&type=script&lang=js&"
import style0 from "./AcordoTabelaDash.vue?vue&type=style&index=0&id=2bc12df5&scoped=true&lang=css&"
import style1 from "../../../../../shared-components/generico/Pagination.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc12df5",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/dashboard/cadeia/AcordoTabelaDash.vue
// module id = 1198
// module chunks = 28